import { useState } from "react";

const C = {
  pink: "#F7A1C4", mint: "#9ED9C3", yellow: "#FFD966",
  blue: "#9CCBFF", lilac: "#D7B7F6", ink: "#1F1F1F", cream: "#FFF8F1",
  pinkSoft: "#FDE8F0", mintSoft: "#E6F5EE", yellowSoft: "#FFF7DC",
  blueSoft: "#E4F0FF", lilacSoft: "#F0E5FC",
};
const heading = "'Baloo 2', cursive, sans-serif";
const body = "'Nunito', sans-serif";
const navMap = { "Home": "home", "Meet The Bunch": "meet", "Classes": "classes", "Gallery": "gallery", "Reviews": "reviews", "Parties": "parties", "Merch": "merch", "Schools": "schools", "Contact": "contact" };


const IMG = {
  logo: "/images/logo.webp",
  pinky: "/images/characters/pinky.webp",
};

const packages = [
  {
    name: "The Mini Disco",
    tier: "Bronze",
    price: 75,
    duration: "45 minutes",
    maxKids: 10,
    color: C.yellow,
    soft: C.yellowSoft,
    features: [
      "Themed warm-up and dance games",
      "Mini disco with party music",
      "Special birthday dance for the birthday child",
      "Parents provide food and decorations",
    ],
  },
  {
    name: "The Funky Party",
    tier: "Silver",
    price: 120,
    duration: "1 hour",
    maxKids: 15,
    color: C.pink,
    soft: C.pinkSoft,
    popular: true,
    features: [
      "Everything in Bronze, plus:",
      "Themed dance session (you choose the theme!)",
      "Party props provided (ribbons, scarves, shakers)",
      "A Funky Bunch sticker for every child",
      "Birthday shout-out on our social media",
    ],
  },
  {
    name: "The Ultimate Funky Bunch Party",
    tier: "Gold",
    price: 175,
    duration: "1.5 hours",
    maxKids: 20,
    color: C.lilac,
    soft: C.lilacSoft,
    features: [
      "Everything in Silver, plus:",
      "Party decorations in the Funky Bunch theme, set up for you",
      "A Funky Bunch t-shirt for the birthday child",
      "Personalised video message from their favourite character",
      "Dedicated time for food and cake between dance sessions",
    ],
  },
];

const DEPOSIT_PERCENT = 0.2;

const RainbowHeading = ({ children, size = 28, tag = "h2" }) => {
  const s = {
    fontFamily: heading, fontSize: size, fontWeight: 800, textAlign: "center",
    lineHeight: 1.3, margin: 0,
    background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac}, ${C.pink})`,
    backgroundSize: "200% 100%",
    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
    backgroundClip: "text", animation: "rainbowSlide 4s linear infinite",
  };
  if (tag === "h1") return <h1 style={s}>{children}</h1>;
  if (tag === "h3") return <h3 style={s}>{children}</h3>;
  return <h2 style={s}>{children}</h2>;
};

const Nav = () => {
  const links = ["Home", "Meet The Bunch", "Classes", "Gallery", "Reviews", "Parties", "Merch", "Schools", "Contact"];
  return (
    <nav style={{
      background: C.cream, padding: "10px 24px",
      position: "sticky", top: 0, zIndex: 100,
      borderBottom: `2px solid ${C.pink}15`,
      boxShadow: "0 2px 16px rgba(0,0,0,0.03)",
    }}>
      <div style={{
        maxWidth: 900, margin: "0 auto",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <img src={IMG.logo} alt="The Funky Bunch" style={{ height: 46, objectFit: "contain", cursor: "pointer" }} onClick={() => { window.location.hash = "home"; }} />
        <div style={{ display: "flex", gap: 2, alignItems: "center", flexWrap: "wrap" }}>
          {links.map(l => (
            <span key={l} style={{
              fontSize: 11.5, fontFamily: body, fontWeight: 600,
              color: l === "Parties" ? C.pink : C.ink + "88",
              padding: "5px 9px", borderRadius: 14,
              background: l === "Parties" ? C.pinkSoft : "transparent",
              cursor: "pointer",
            }} onClick={() => { window.location.hash = navMap[l]; }}>{l}</span>
          ))}
          <span style={{
            background: C.pink, color: "#fff", padding: "7px 18px",
            borderRadius: 50, fontFamily: heading, fontWeight: 700, fontSize: 12,
            cursor: "pointer", marginLeft: 4,
          }} onClick={() => { window.location.hash = "classes"; }}>Book Now</span>
        </div>
      </div>
    </nav>
  );
};

const Footer = () => (
  <footer style={{ background: C.cream, padding: "36px 24px 20px", borderTop: `2px solid ${C.pink}15` }}>
    <div style={{ maxWidth: 900, margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 28, marginBottom: 24 }}>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Find Us</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>Lumina Dance Company<br />Eden Business Centre<br />South Stour Ave, Ashford<br />Kent TN23 7RS</div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Classes</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>Term-time Thursdays<br />10:30 – 11:15</div>
        </div>
        <div>
          <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 6 }}>Get in Touch</div>
          <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "88", lineHeight: 1.8 }}>thefunkybunchashford@gmail.com</div>
          <div style={{ display: "flex", gap: 10, marginTop: 6 }}>
            <a href="https://www.facebook.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.blue}><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg></a>
            <a href="https://www.instagram.com/thefunkybunchkent" target="_blank" rel="noopener noreferrer"><svg width="20" height="20" viewBox="0 0 24 24" fill={C.pink}><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg></a>
          </div>
        </div>
      </div>
      <div style={{ height: 3, borderRadius: 2, marginBottom: 14, background: `linear-gradient(90deg, ${C.pink}, ${C.yellow}, ${C.mint}, ${C.blue}, ${C.lilac})` }} />
      <div style={{ fontFamily: body, fontSize: 10, color: C.ink + "55", textAlign: "center" }}>© 2026 The Funky Bunch Kent. All rights reserved.</div>
    </div>
  </footer>
);

export default function PartiesPage() {
  const [selectedPkg, setSelectedPkg] = useState(null);
  const [showBooking, setShowBooking] = useState(false);
  const [childName, setChildName] = useState("");
  const [childAge, setChildAge] = useState("");
  const [parentName, setParentName] = useState("");
  const [parentEmail, setParentEmail] = useState("");
  const [parentPhone, setParentPhone] = useState("");
  const [partyDate, setPartyDate] = useState("");
  const [partyTime, setPartyTime] = useState("");
  const [venueAddress, setVenueAddress] = useState("");
  const [theme, setTheme] = useState("");
  const [notes, setNotes] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [photoConsent, setPhotoConsent] = useState(false);
  const [checkoutError, setCheckoutError] = useState("");

  const pkg = selectedPkg !== null ? packages[selectedPkg] : null;
  const deposit = pkg ? (pkg.price * DEPOSIT_PERCENT).toFixed(2) : 0;
  const balance = pkg ? (pkg.price - pkg.price * DEPOSIT_PERCENT).toFixed(2) : 0;

  const inputStyle = {
    width: "100%", padding: "11px 14px", borderRadius: 12,
    border: `1.5px solid ${C.pink}30`, fontSize: 14,
    outline: "none", background: C.cream, fontFamily: body,
    marginBottom: 10,
  };

  return (
    <div style={{ background: C.cream, minHeight: "100vh" }}>
      <link href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;500;600;700;800&family=Nunito:wght@400;500;600;700;800&display=swap" rel="stylesheet" />
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        @keyframes rainbowSlide {
          0% { background-position: 0% 50%; }
          100% { background-position: 200% 50%; }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
        button:hover { transform: scale(1.03); transition: transform 0.2s; }
        button:active { transform: scale(0.98); }
        input, select, textarea { font-family: 'Nunito', sans-serif; }
      `}</style>

      <Nav />

      {/* Hero */}
      <section style={{
        background: `linear-gradient(180deg, ${C.cream} 0%, ${C.pinkSoft} 100%)`,
        padding: "36px 24px 28px", textAlign: "center",
      }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={28} tag="h1">Birthday Parties</RainbowHeading>
          <p style={{
            fontFamily: body, fontSize: 15, color: C.ink + "aa",
            lineHeight: 1.6, margin: "8px auto 0", maxWidth: 480,
          }}>
            We come to you! Choose a package, pick a theme and let The Funky Bunch bring the fun to your child's special day. For children up to age 8.
          </p>
        </div>
      </section>

      {/* Packages */}
      <section style={{ padding: "32px 24px 20px" }}>
        <div style={{
          maxWidth: 900, margin: "0 auto",
          display: "flex", gap: 20, justifyContent: "center",
          flexWrap: "wrap",
        }}>
          {packages.map((p, i) => (
            <div key={i} style={{
              flex: "1 1 250px", maxWidth: 290,
              background: selectedPkg === i ? p.soft : "#fff",
              borderRadius: 24, padding: "28px 22px",
              border: `3px solid ${selectedPkg === i ? p.color : p.color + "30"}`,
              position: "relative",
              transition: "all 0.3s ease",
              cursor: "pointer",
            }} onClick={() => { setSelectedPkg(i); setShowBooking(false); }}>
              {p.popular && (
                <div style={{
                  position: "absolute", top: -10, right: 16,
                  background: p.color, color: "#fff", fontSize: 10,
                  fontFamily: heading, fontWeight: 700, padding: "3px 14px",
                  borderRadius: 20,
                }}>MOST POPULAR</div>
              )}
              <div style={{
                fontFamily: body, fontWeight: 700, fontSize: 11,
                color: p.color, textTransform: "uppercase", letterSpacing: 1.5,
                marginBottom: 4,
              }}>{p.tier}</div>
              <div style={{
                fontFamily: heading, fontWeight: 800, fontSize: 18,
                color: C.ink, marginBottom: 8,
              }}>{p.name}</div>
              <div style={{
                fontFamily: heading, fontSize: 36, fontWeight: 800,
                color: C.ink, marginBottom: 4,
              }}>£{p.price}</div>
              <div style={{
                fontFamily: body, fontSize: 12, color: C.ink + "77",
                marginBottom: 16,
              }}>
                {p.duration} · Up to {p.maxKids} children
              </div>
              {p.features.map((f, fi) => (
                <div key={fi} style={{
                  display: "flex", alignItems: "flex-start", gap: 8,
                  marginBottom: 6,
                }}>
                  <div style={{
                    width: 6, height: 6, borderRadius: "50%",
                    background: p.color, flexShrink: 0, marginTop: 6,
                  }} />
                  <span style={{
                    fontFamily: body, fontSize: 12.5,
                    color: fi === 0 && i > 0 ? p.color : C.ink + "aa",
                    fontWeight: fi === 0 && i > 0 ? 700 : 400,
                    lineHeight: 1.5,
                  }}>{f}</span>
                </div>
              ))}
              <button
                onClick={(e) => { e.stopPropagation(); setSelectedPkg(i); setShowBooking(true); }}
                style={{
                  width: "100%", marginTop: 16,
                  background: selectedPkg === i ? p.color : p.color + "33",
                  color: selectedPkg === i ? "#fff" : C.ink,
                  border: "none", padding: "12px", borderRadius: 50,
                  fontFamily: heading, fontWeight: 700, fontSize: 14,
                  cursor: "pointer", transition: "all 0.3s",
                }}
              >
                {selectedPkg === i ? "Selected" : "I'm interested"}
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* Venue note */}
      <section style={{ padding: "0 24px 20px" }}>
        <div style={{
          maxWidth: 560, margin: "0 auto",
          background: C.mintSoft, borderRadius: 16,
          border: `2px solid ${C.mint}30`,
          padding: "16px 20px", textAlign: "center",
        }}>
          <div style={{ fontFamily: body, fontSize: 13, color: C.ink + "aa", lineHeight: 1.6 }}>
            <strong style={{ color: C.ink }}>We come to you!</strong> All birthday parties are held at a venue of your choice. You provide the space, we bring the fun.
          </div>
        </div>
      </section>

      {/* How it works */}
      <section style={{ padding: "20px 24px 32px" }}>
        <div style={{ maxWidth: 600, margin: "0 auto" }}>
          <RainbowHeading size={20} tag="h3">How it works</RainbowHeading>
          <div style={{ height: 16 }} />
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap", justifyContent: "center" }}>
            {[
              { step: "1", title: "Choose your package", desc: "Pick Bronze, Silver or Gold", color: C.yellow },
              { step: "2", title: "Tell us about your party", desc: "Fill in a few details", color: C.pink },
              { step: "3", title: "We'll get back to you", desc: "Usually within 24 hours", color: C.blue },
              { step: "4", title: "Party time!", desc: "We bring the fun to you", color: C.mint },
            ].map((s, i) => (
              <div key={i} style={{
                flex: "1 1 120px", maxWidth: 150,
                textAlign: "center",
              }}>
                <div style={{
                  width: 40, height: 40, borderRadius: "50%",
                  background: s.color + "33", margin: "0 auto 8px",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontFamily: heading, fontWeight: 800, fontSize: 16, color: s.color,
                }}>{s.step}</div>
                <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 13, color: C.ink, marginBottom: 2 }}>{s.title}</div>
                <div style={{ fontFamily: body, fontSize: 11, color: C.ink + "77" }}>{s.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Expression of interest form */}
      {showBooking && pkg && (
        <section style={{ padding: "0 24px 48px", animation: "fadeIn 0.4s ease" }}>
          <div style={{
            maxWidth: 560, margin: "0 auto",
            background: "#fff", borderRadius: 24,
            border: `2px solid ${pkg.color}25`,
            padding: "32px 28px",
          }}>
            <RainbowHeading size={20} tag="h3">Enquire about a {pkg.tier} party</RainbowHeading>
            <p style={{
              fontFamily: body, fontSize: 13, color: C.ink + "88",
              textAlign: "center", margin: "8px 0 20px", lineHeight: 1.5,
            }}>
              Tell us a bit about what you're looking for and we'll get back to you within 24 hours.
            </p>

            {/* Birthday child */}
            <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 10 }}>
              Birthday child
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <input type="text" placeholder="Child's name" value={childName}
                onChange={e => setChildName(e.target.value)} style={{ ...inputStyle, flex: 1 }} />
              <input type="text" placeholder="Age" value={childAge}
                onChange={e => setChildAge(e.target.value)} style={{ ...inputStyle, width: 70 }} />
            </div>

            {/* Parent details */}
            <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 10, marginTop: 8 }}>
              Your details
            </div>
            <input type="text" placeholder="Your name" value={parentName}
              onChange={e => setParentName(e.target.value)} style={inputStyle} />
            <input type="email" placeholder="Email address" value={parentEmail}
              onChange={e => setParentEmail(e.target.value)} style={inputStyle} />
            <input type="tel" placeholder="Phone number" value={parentPhone}
              onChange={e => setParentPhone(e.target.value)} style={inputStyle} />

            {/* Party details */}
            <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink, marginBottom: 10, marginTop: 8 }}>
              Party details
            </div>
            <div style={{ display: "flex", gap: 10 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontFamily: body, fontSize: 11, color: C.ink + "77", marginBottom: 4 }}>Preferred date</div>
                <input type="date" value={partyDate}
                  onChange={e => setPartyDate(e.target.value)} style={{ ...inputStyle }} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontFamily: body, fontSize: 11, color: C.ink + "77", marginBottom: 4 }}>Preferred time</div>
                <input type="time" value={partyTime}
                  onChange={e => setPartyTime(e.target.value)} style={{ ...inputStyle }} />
              </div>
            </div>
            <input type="text" placeholder="Venue address (or area if not yet confirmed)" value={venueAddress}
              onChange={e => setVenueAddress(e.target.value)} style={inputStyle} />
            {selectedPkg > 0 && (
              <input type="text" placeholder="Preferred theme (e.g. Under The Sea, Cowboys...)" value={theme}
                onChange={e => setTheme(e.target.value)} style={inputStyle} />
            )}
            <textarea placeholder="Anything else you'd like us to know?" value={notes}
              onChange={e => setNotes(e.target.value)}
              style={{ ...inputStyle, minHeight: 70, resize: "vertical" }} />

            {/* Package summary */}
            <div style={{
              background: pkg.soft, borderRadius: 16, padding: "16px 20px",
              marginBottom: 20,
              display: "flex", justifyContent: "space-between", alignItems: "center",
            }}>
              <div>
                <div style={{ fontFamily: heading, fontWeight: 700, fontSize: 14, color: C.ink }}>{pkg.tier} package</div>
                <div style={{ fontFamily: body, fontSize: 12, color: C.ink + "77" }}>{pkg.duration} · Up to {pkg.maxKids} children</div>
              </div>
              <div style={{ fontFamily: heading, fontWeight: 800, fontSize: 22, color: C.ink }}>£{pkg.price}</div>
            </div>

            {/* Submit */}
            <button
              onClick={async () => {
                try {
                  await fetch("/.netlify/functions/contact", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      type: "party",
                      name: parentName,
                      email: parentEmail,
                      phone: parentPhone,
                      childName,
                      childAge,
                      pkg: pkg.tier,
                      partyDate,
                      partyTime,
                      venue: venueAddress,
                      theme,
                      notes,
                    }),
                  });
                  alert("Enquiry sent! We'll get back to you within 24 hours.");
                } catch (err) {
                  alert("Enquiry sent! We'll get back to you within 24 hours.");
                }
              }}
              style={{
                width: "100%",
                background: pkg.color, color: "#fff", border: "none",
                padding: "16px", borderRadius: 50,
                fontFamily: heading, fontWeight: 700, fontSize: 16,
                cursor: "pointer",
              }}
            >
              Send Enquiry
            </button>
            <div style={{
              textAlign: "center", marginTop: 10,
              fontFamily: body, fontSize: 11, color: C.ink + "55",
            }}>
              We'll get back to you within 24 hours
            </div>
          </div>
        </section>
      )}

      {/* CTA */}
      <section style={{
        background: `linear-gradient(135deg, ${C.pinkSoft}, ${C.lilacSoft}, ${C.blueSoft})`,
        padding: "48px 24px", textAlign: "center",
      }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <RainbowHeading size={22}>Got questions?</RainbowHeading>
          <p style={{ fontFamily: body, fontSize: 14, color: C.ink + "99", margin: "8px 0 24px" }}>
            Get in touch and we can chat about the perfect party for your little one.
          </p>
          <a href="mailto:thefunkybunchashford@gmail.com" style={{
            background: C.pink, color: "#fff", border: "none",
            padding: "14px 36px", borderRadius: 50,
            fontFamily: heading, fontWeight: 700, fontSize: 16,
            cursor: "pointer", textDecoration: "none", display: "inline-block",
          }}>Get in Touch</a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
